import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import { IoIosArrowForward } from "react-icons/io"
import PageTransition from "../components/page-transition";
import Target from "../components/Cursor/target";
import DribbleShots from "../components/dribble_shots";
import Layout from "../components/layout"
import SEO from "../components/seo"

import './../styles/about.scss';

const BannerSection = () => {
  return (
    <div className="BannerWrap">
      <div className="hp-container">
        <div className="Banner">
          <h1 className="title">
            Designer from Computer Science <span>engineering</span> background.
          </h1>
          <div className="description">
            <h4>
              Hi, I'm Hariprasath , a Minimalist Designer. I like things around
              to be Organized. Currently i am working as ux/ui designer in
              chennai beased startup and i have worked with some great clients
              &amp; delivered amazing products which users enjoy. I enjoy
              turning complex problems into simple, beautiful and intuitive
              designs.
            </h4>
            <Target>
              <PageTransition to="/resume" className="aboutMeLink">
                <h5>Resume</h5>
                <IoIosArrowForward size={20} className="arrow" />
              </PageTransition>
            </Target>
          </div>
        </div>
      </div>
    </div>
  )
}

const SkillSetSection = ({ bg, toolsImg }) => {
  return (
    <div className="SkillsetWrap">
      <div className="hp-container">
        <h2>Skillset</h2>
      </div>
      <div className="SkillsetContent">
        <div className="hp-container">
          <div className="SkillsetBg">
            <Img fluid={bg} />
          </div>
          <div className="SkilletData">
            <div>
              <div className="Type">
                <h4>Design</h4>
                <ul>
                  <li>
                    <h5>UX/UI Design</h5>
                  </li>
                  <li>
                    <h5>Website Design</h5>
                  </li>
                  <li>
                    <h5>Mobile App Design</h5>
                  </li>
                  <li>
                    <h5>Prototyping &amp; Testing</h5>
                  </li>
                  <li>
                    <h5>Typography</h5>
                  </li>
                  <li>
                    <h5>Graphics Design</h5>
                  </li>
                  <li>
                    <h5>Wireframes</h5>
                  </li>
                </ul>
              </div>
              <div className="Type">
                <h4>Design</h4>
                <ul>
                  <li>
                    <h5>Interaction Design</h5>
                  </li>
                  <li>
                    <h5>Presentation Videos</h5>
                  </li>
                  <li>
                    <h5>App Presentation</h5>
                  </li>
                  <li>
                    <h5>Slideshows</h5>
                  </li>
                  <li>
                    <h5>Promo Videos</h5>
                  </li>
                </ul>
              </div>
            </div>
            <div className="Type fullWidth">
              <h4>
                Development
                <span className="soonBadge">Soon!</span>
              </h4>
            </div>
            <div className="Type fullWidth lastrow">
              <h4>I Expertise in</h4>
              <div className="ToolsList">
                {new Array(11).fill(0).map((_name, index) => (
                  <li>
                    <Img
                      fixed={toolsImg[`tool${index + 1}`].childImageSharp.fixed}
                    />
                  </li>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const AboutPage = () => {
  const data = useStaticQuery(graphql`
    query {
      bgLogo: file(relativePath: { eq: "icon-bg.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, maxHeight: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      skillset: file(relativePath: { eq: "skillset.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 525, maxHeight: 560) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      tool1: file(relativePath: { eq: "tools/tool1.png" }) {
        childImageSharp {
          fixed(width: 26, height: 26, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      tool2: file(relativePath: { eq: "tools/tool2.png" }) {
        childImageSharp {
          fixed(width: 26, height: 26, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      tool3: file(relativePath: { eq: "tools/tool3.png" }) {
        childImageSharp {
          fixed(width: 26, height: 26, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      tool4: file(relativePath: { eq: "tools/tool4.png" }) {
        childImageSharp {
          fixed(width: 26, height: 26, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      tool5: file(relativePath: { eq: "tools/tool5.png" }) {
        childImageSharp {
          fixed(width: 26, height: 26, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      tool6: file(relativePath: { eq: "tools/tool6.png" }) {
        childImageSharp {
          fixed(width: 26, height: 26, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      tool7: file(relativePath: { eq: "tools/tool7.png" }) {
        childImageSharp {
          fixed(width: 26, height: 26, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      tool8: file(relativePath: { eq: "tools/tool8.png" }) {
        childImageSharp {
          fixed(width: 26, height: 26, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      tool9: file(relativePath: { eq: "tools/tool9.png" }) {
        childImageSharp {
          fixed(width: 26, height: 26, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      tool10: file(relativePath: { eq: "tools/tool10.png" }) {
        childImageSharp {
          fixed(width: 26, height: 26, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      tool11: file(relativePath: { eq: "tools/tool11.png" }) {
        childImageSharp {
          fixed(width: 26, height: 26, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO title="About me" />
      <div className="hp-bg-img-container">
        <Img
          fluid={data.bgLogo.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
        />
      </div>
      <BannerSection />
      <SkillSetSection
        toolsImg={data}
        bg={data.skillset.childImageSharp.fluid}
      />
      <DribbleShots />
    </Layout>
  )
}

export default AboutPage
